// import { landingNameSpace } from "../components/features/landing/landing.i18n";

let en = {
  // landing: landingNameSpace.en,
};

export default en;
